import { Injectable } from '@angular/core';
export interface PuntoConOrden extends google.maps.LatLngLiteral {
  ordenVisita: number;
}

export interface GeoItem {
  listaConGeo: any[];
  dentroDelRadio?: boolean;
}


export interface PostalAddress {
  regionCode?: string;
  languageCode?: string;
  postalCode?: string;
  administrativeArea?: string;
  locality?: string;
  addressLines?: string[];
}

export interface DireccionNormalizada {
  pais: string;
  codigoPostal: string;
  departamento: string;
  ciudad: string;
  direccion: string;
  direccionCompleta: string;
  codigoIdioma?: string;
}

export interface GeoPoint {
  lat: number;
  lng: number;
  type: "google" | "here" | "report" | "point";
  metadata?: {
    sitioValido?: boolean;
    address?: string;
    name?: string;
  };
}

export interface RegistroEntrega {
  direccion_geo: string;
  sitio_reporte: string;
  metros_reporte: string;
  latTarea: number;
  lonTarea: number;
}
export interface AddressValidationResult {
  isValid: boolean;
  reason: string;
}

const tiposVia: Record<string, string> = {
  'KR': 'Carrera', 'CRA': 'Carrera', 'CARRERA': 'Carrera',
  'CL': 'Calle', 'CALLE': 'Calle',
  'DG': 'Diagonal', 'DIAG': 'Diagonal', 'DIAGONAL': 'Diagonal',
  'TV': 'Transversal', 'TRANSV': 'Transversal', 'TRANSVERSAL': 'Transversal',
  'AV': 'Avenida', 'AVEN': 'Avenida', 'AVENIDA': 'Avenida',
  'AK': 'Avenida Kr', 'AC': 'Autopista', 'AUT': 'Autopista',
  'CIRC': 'Circular', 'CIRCUNVALAR': 'Circunvalar',
  'MANZ': 'Manzana', 'MZ': 'Manzana', 'MNZ': 'Manzana'
};



// 1. Primero definimos cómo se verá cada tipo de marcador
const estilosMarcadores = {
  google: {
    forma: "M 0,-15 L 12,10 L -12,10 Z", // Triángulo
    colorBorde: "orange",
    tamaño: 1.5
  },
  here: {
    forma: "M 0,-15 L 14,-5 L 9,12 L -9,12 L -14,-5 Z", // Pentágono
    colorBorde: "blue",
    tamaño: 1
  },
  report: {
    forma: "M -5,-5 L 5,-5 L 5,5 L -5,5 Z", // Cuadrado
    colorBorde: "green",
    tamaño: 3
  },
  point: {
    forma: google.maps.SymbolPath.CIRCLE, // Círculo
    colorBorde: "#FF0000", // Rojo por defecto
    tamaño: 10
  }
};



@Injectable({
  providedIn: 'root'
})



export class GeolocationManagerService {
  private readonly addressRegex = /^(CLL|CL|Calle|Calle|Carrera|Cra|CR|Diagonal|Dg|Transversal|Tr|Avenida|Av|AV)\s+(\d+)\s*([A-Za-z]?)\s*(\d+)\s*(\d*)$/i;
  
  constructor() { }
  validateAddress(address: string): boolean {
    return this.addressRegex.test(address.trim());
  }
  formatAddressInit(address: string): string {
    if (!this.validateAddress(address)) {
      return address; // Retorna la dirección original si no cumple el formato
    }

    const match = address.trim().match(this.addressRegex);
    if (!match) return address;

    // Extraer componentes
    const type = match[1].toLowerCase();
    const mainNumber = match[2];
    const letter = match[3].toLowerCase();
    const secondaryNumber = match[4];
    const complement = match[5];

    // Formatear tipo de vía
    let formattedType = 'Calle';
    if (type.match(/^(cll|cl|calle)$/i)) formattedType = 'Calle';
    else if (type.match(/^(cra|cr|carrera)$/i)) formattedType = 'Carrera';
    else if (type.match(/^(dg|diagonal)$/i)) formattedType = 'Diagonal';
    else if (type.match(/^(tr|transversal)$/i)) formattedType = 'Transversal';
    else if (type.match(/^(av|avenida)$/i)) formattedType = 'Avenida';

    // Construir dirección formateada
    let formattedAddress = `${formattedType} ${mainNumber}${letter}`;
    if (secondaryNumber) {
      formattedAddress += ` ${secondaryNumber}`;
      if (complement) {
        formattedAddress += `-${complement}`;
      }
    }

    return formattedAddress;
  }

  obtenerZonaDesdeDireccion(direccion: string, enSitio: boolean = false): string {
    if (!direccion) return '';
  
    const partes = direccion.split(',').map(p => p.trim());
  
    if (enSitio && partes.length > 1) {
      // Quitamos la primera parte (que suele contener calle y número)
      return partes.slice(1).join(', ');
    }
  
    // Por defecto, devolver las últimas 3 partes
    return partes.slice(-3).join(', ');
  }
  
  
  agregarZonaUnica(zona: string, lista: string[]): void {
    if (zona && !lista.includes(zona)) {
      lista.push(zona);
    }
  }

  construirDireccion(direccion: any): string {
    const { 
      countryName,
      county,
      city,
      district,
      postalCode,


    } = direccion;
  
    // Construir la dirección con street pero sin houseNumber
    const partesDireccion = [

      district,
      city,
      county,
      postalCode,
      countryName
    ];
  
    // Filtrar partes vacías y unir con comas
    return partesDireccion.filter(part => part && part.trim() !== '').join(', ');
  }
  
  

   normalizarTexto(texto: string): string {
    return texto
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Eliminar tildes
      .replace(/[^\w\s]/g, "")         // Eliminar signos de puntuación
      .replace(/\s+/g, " ")            // Espacios múltiples
      .trim();
  }
  
   expandirSiglas(texto: string): string {
    const palabras = texto.split(" ");
    return palabras.map(palabra => tiposVia[palabra] || palabra).join(" ");
  }
  
   extraerDireccionPrincipal(direccion: string): string {
    const partes = direccion.split("/");
    return partes[0].trim();
  }
  
   direccionMasProbabledos(direccionInicial: string, lista: string[]): string | null {
    const base = this.expandirSiglas(this.normalizarTexto(this.extraerDireccionPrincipal(direccionInicial)));
  
    let mejorCoincidencia: string | null = null;
    let mayorSimilitud = 0;
  
    for (const direccion of lista) {
      const normalizada = this.expandirSiglas(this.normalizarTexto(direccion));
  
      const coincidencia = this.obtenerSimilitud(base, normalizada);
  
      if (coincidencia > mayorSimilitud) {
        mayorSimilitud = coincidencia;
        mejorCoincidencia = direccion;
      }
    }
  
    return mejorCoincidencia;
  }

  direccionMasProbable(direccionInicial: string, lista: string[]): string | null {
    const base = this.expandirSiglas(this.normalizarTexto(this.extraerDireccionPrincipal(direccionInicial)));
    
    let mejorCoincidencia: string | null = null;
    let mayorPuntaje = -1;
  
    for (const direccion of lista) {
      const normalizada = this.expandirSiglas(this.normalizarTexto(direccion));
      
      const similitud = this.obtenerSimilitud(base, normalizada);
  
      // BONUS: Contar cuántos números hay (más números => más precisa)
      const numeros = (normalizada.match(/\d+/g) || []).length;
  
      // PENALIZAR si contiene "undefined" u otras palabras sospechosas
      const penalizacion = /undefined|sin\s+direccion|n\/a/.test(normalizada) ? -0.5 : 0;
  
      // Calcular puntaje final ponderado
      const puntaje = similitud + numeros * 0.5 + penalizacion;
  
      if (puntaje > mayorPuntaje) {
        mayorPuntaje = puntaje;
        mejorCoincidencia = direccion;
      }
    }
  
    return mejorCoincidencia;
  }
  
  
  // Comparador simple basado en número de palabras iguales
   obtenerSimilitud(texto1: string, texto2: string): number {
    const palabras1 = new Set(texto1.split(" "));
    const palabras2 = new Set(texto2.split(" "));
    const comunes = [...palabras1].filter(p => palabras2.has(p));
    return comunes.length;
  }
  
  

  obtenerDireccionMasCercana(lista: RegistroEntrega[]): { 
    direccion: string | null, 
    enSitio: boolean,
    latitud?: number | null,
    longitud?: number | null 
  } {
    if (!lista || lista.length === 0) return { 
      direccion: null, 
      enSitio: false,
      latitud: null,
      longitud: null
    };
  
    const parseMetros = (m: string): number => {
      const n = parseFloat(m);
      return isNaN(n) ? Number.MAX_SAFE_INTEGER : n;
    };
  
    const conSitioReporte = lista.filter(item => item.sitio_reporte === "SI");
    const candidatosSinFiltrar = conSitioReporte.length > 0 ? conSitioReporte : lista;
  
    // Filtrar por distancia menor o igual a 3000
    const candidatos = candidatosSinFiltrar.filter(item => parseMetros(item.metros_reporte) <= 3000);
  
    if (candidatos.length === 0) {
      return {
        direccion: null,
        enSitio: false,
        latitud: null,
        longitud: null
      };
    }
  
    let mejor = candidatos[0];
    let menorDistancia = parseMetros(mejor.metros_reporte);
  
    for (const item of candidatos) {
      const distancia = parseMetros(item.metros_reporte);
      if (distancia < menorDistancia) {
        mejor = item;
        menorDistancia = distancia;
      }
    }
  
    return {
      direccion: mejor.direccion_geo || null,
      enSitio: mejor.sitio_reporte === "SI",
      latitud: mejor.latTarea || null,
      longitud: mejor.lonTarea || null
    };
  }
  
  


   normalizarDireccion(direccion: string): string {
    return direccion
      .toLowerCase()
      .replace(/calle/g, 'cl')
      .replace(/#/g, '')
      .replace(/[^\w\s]/gi, '') // elimina símbolos raros
      .replace(/\s+/g, ' ')     // elimina espacios múltiples
      .trim();
  }
  
   calcularSimilitudExacta(base: string, candidata: string): number {
    const dirBase = this.normalizarDireccion(base);
    const dirCandidata = this.normalizarDireccion(candidata);

    console.log("dirBase",dirBase)
    console.log("dirCandidata",dirCandidata)
  
    // Similitud exacta por caracteres iguales en secuencia (más preciso)
    let iguales = 0;
    const minLen = Math.min(dirBase.length, dirCandidata.length);
  
    for (let i = 0; i < minLen; i++) {
      if (dirBase[i] === dirCandidata[i]) {
        iguales++;
      }
    }
    console.log("porcentaje",iguales / dirBase.length)
    return iguales / dirBase.length; // valor entre 0 y 1
  }
  
   evaluarDireccion(
    original: string,
    candidatas: string[]
  ): { mejorCoincidencia: string; puntaje: number } {
    let mejorCoincidencia = '';
    let mejorPuntaje = -1;
  
    const direccionOriginalNormalizada = this.normalizarDireccion(original);
  
    for (const candidata of candidatas) {
      const partes = candidata.split(',');
      const direccionBase = partes[0]; // Ej: Cl. 52 # 50A-42
      const direccionNormalizada = this.normalizarDireccion(direccionBase);

      const similitud = this.calcularSimilitudExacta(direccionOriginalNormalizada, direccionNormalizada);
  
      const camposExtras = partes.length - 1; // barrio, ciudad, etc.
  
      // 💡 Ahora damos más peso a la similitud exacta
      const puntaje = similitud * 90 + camposExtras * 5;
  
      if (puntaje > mejorPuntaje) {
        mejorCoincidencia = candidata;
        mejorPuntaje = puntaje;
      }
    }
  
    return {
      mejorCoincidencia,
      puntaje: Math.round(mejorPuntaje)
    };
  }
  

// 2. Función para crear cualquier marcador
 crearMarcadorSimple(mapa, posicion, indice, tipo, colorPersonalizado = null) {
  const estilo = estilosMarcadores[tipo];
  
  return new google.maps.Marker({
    position: posicion,
    map: mapa,
    label: {
      text: indice.toString(),
      color: "#000",
      fontSize: "8px"
    },
    icon: {
      path: estilo.forma,
      fillColor: "#FFFF",
      fillOpacity: 0.5,
      strokeColor: colorPersonalizado || estilo.colorBorde,
      strokeWeight: 2,
      scale: estilo.tamaño
    }
  });
}

agregarMarcadores(item, indice, mapa, colorEspecial) {
  item.VRTIA_ListaConGeo.forEach((punto, index) => {
    try {
      if (!punto.lat || punto.lat === 0.0) return; // Saltar coordenadas inválidas

      const posicion = { lat: punto.lat, lng: punto.lng };

      switch (punto.type) {
        case 'google':
        case 'here':
        case 'report':
          this.crearMarcadorSimple(mapa, posicion, indice, punto.type);
          break;

        case 'point':
          const marcador = this.crearMarcadorSimple(mapa, posicion, indice, 'point', colorEspecial);

          const popup = new google.maps.InfoWindow({
            content: `
              <div class="mapa-popup">
                <h4>${item.Address || 'Ubicación'}</h4>
                <p><b>Cliente:</b> ${item.Name || 'No especificado'}</p>
              </div>
            `
          });

          marcador.addListener('click', () => {
            mapa.setCenter(marcador.getPosition());
            mapa.setZoom(14);
            popup.open(mapa, marcador);
          });
          break;
      }
    } catch (error) {
      console.error(`❌ Error al agregar marcador en índice ${index} del item`, punto);
      console.error("➡️ Detalle del error:", error);
    }
  });
}

  estanTodosDentroDelRadio(
    puntos: { lat: number, lng: number }[],
    radioMaximoMetros: number
  ): { dentroDelRadio: boolean, distanciaMaxima: number } {

    let distanciaMaxima = 0;

    for (let i = 0; i < puntos.length; i++) {
      for (let j = i + 1; j < puntos.length; j++) {
        const distancia = this.calcularDistancia(
          puntos[i].lat, puntos[i].lng,
          puntos[j].lat, puntos[j].lng
        );

        // Actualizar la distancia máxima encontrada
        if (distancia > distanciaMaxima) {
          distanciaMaxima = distancia;
        }

        if (distancia > radioMaximoMetros) {
          console.warn(`Puntos ${i} y ${j} están a ${distancia.toFixed(2)} metros (más de ${radioMaximoMetros}m)`);
          return { dentroDelRadio: false, distanciaMaxima };
        }
      }
    }

    return { dentroDelRadio: true, distanciaMaxima };
  }
  
  /**
 * Genera URL de StreetView y actualiza coordenadas por referencia
 * @param businessData Objeto con los datos del negocio (debe contener geometry.location)
 * @param coords Objeto opcional donde se guardarán las coordenadas (si se provee)
 * @returns URL de StreetView o null si no se pudo generar
 */
 generarStreetView(businessData: any, coords?: { lat?: number, lng?: number }): string | null {
  // Verificación manual de la estructura sin operador ?.
  if (businessData && 
      businessData.findClosestBusinessByName && 
      businessData.findClosestBusinessByName.geometry && 
      businessData.findClosestBusinessByName.geometry.location) {
      
      const location = businessData.findClosestBusinessByName.geometry.location;
      const lat = parseFloat(location.lat);
      const lng = parseFloat(location.lng);

      // Validación numérica
      if (!isNaN(lat) && !isNaN(lng)) {
          // Actualiza coordenadas si se proporcionó el objeto
          if (coords) {
              coords.lat = lat;
              coords.lng = lng;
          }

          // Construye URL manualmente (sin template literals)
          return 'https://www.google.com/maps/@?api=1&map_action=pano' +
                 '&viewpoint=' + lat + ',' + lng +
                 '&heading=0&pitch=0&fov=80';
      }
  }
  return null;
}



getStreetViewUrl(data: any, resultados: any): string | null {
  let lat: number | null = null;
  let lng: number | null = null;

  // Primero intentamos con la fuente principal
  if (
    data &&
    data.VRTIA_FindClosestBusinessByName &&
    data.VRTIA_FindClosestBusinessByName.geometry &&
    data.VRTIA_FindClosestBusinessByName.geometry.location
  ) {
    lat = data.VRTIA_FindClosestBusinessByName.geometry.location.lat;
    lng = data.VRTIA_FindClosestBusinessByName.geometry.location.lng;
  }

  // Si no hay datos, usamos la fuente alternativa
  if ((lat == null || lng == null) &&
      resultados &&
      resultados.googleData &&
      resultados.googleData.result &&
      resultados.googleData.result.geocode &&
      resultados.googleData.result.geocode.location) {
    lat = resultados.googleData.result.geocode.location.lat;
    lng = resultados.googleData.result.geocode.location.lng;
  }

  // Si tenemos lat y lng, devolvemos la URL
  if (lat != null && lng != null) {
    const baseUrl = 'https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=';
    return `${baseUrl}${lat},${lng}&heading=0&pitch=0&fov=80`;
  }

  // Si no hay datos válidos
  return null;
}


  crearListaGeolocalizacion(
    geoGoogle: { latitude: number; longitude: number } | null,
    geoHere: { lat: number; lng: number } | null,
    reportes: Array<{ latTarea: number; lonTarea: number; sitio_reporte?: string }>,
    point: { Latitud: number; Longitud: number } | null
  ): GeoPoint[] {
    const listaGeo: GeoPoint[] = [];
  
    // 1. Añadir geocodificación Google (si existe)
    if (geoGoogle) {
      listaGeo.push({
        lat: geoGoogle.latitude,
        lng: geoGoogle.longitude,
        type: "google"
      });
    }
  
    // 2. Añadir geocodificación HERE (si existe)
    if (geoHere) {
      listaGeo.push({
        lat: geoHere.lat,
        lng: geoHere.lng,
        type: "here"
      });
    }
  
    // 3. Añadir reportes (filtra coordenadas 0,0)
    reportes.forEach(reporte => {
      if (reporte.lonTarea !== 0 && reporte.latTarea !== 0) {
        listaGeo.push({
          lat: reporte.latTarea,
          lng: reporte.lonTarea,
          type: "report",
          metadata: {
            sitioValido: reporte.sitio_reporte === "SI"
          }
        });
      }
    });
  
    // 4. Añadir punto manual (si existe)
    if (point) {
      listaGeo.push({
        lat: point.Latitud,
        lng: point.Longitud,
        type: "point"
      });
    }
  
    return listaGeo;
  }

  calcularScorePorItem(item: any): number {
    const cantidadGeos = item.listaConGeo.length;
    
    if (cantidadGeos > 2) {
      // Caso para más de 2 geolocalizaciones
      return item.dentroDelRadio ? 100 : 70;
    }
    
    // Casos para 3 o menos geolocalizaciones
    switch (cantidadGeos) {
      case 3:
        return 70;
      case 2:
        return 50;
      case 1:
        return 20;
      default:
        return 0;
    }
  }

  extraerDireccionPostal(postalAddress: PostalAddress): DireccionNormalizada {
    // Valores por defecto para manejar casos undefined
    const defaults = {
      regionCode: '',
      postalCode: '',
      administrativeArea: '',
      locality: '',
      addressLines: ['']
    };
  
    // Extraer valores con protección contra undefined
    const {
      regionCode = defaults.regionCode,
      languageCode,
      postalCode = defaults.postalCode,
      administrativeArea = defaults.administrativeArea,
      locality = defaults.locality,
      addressLines = defaults.addressLines
    } = postalAddress;
  
    // Obtener la primera línea de dirección (o cadena vacía)
    const lineaDireccion = addressLines[0] || '';
  
    // Construir dirección completa
    const partesDireccion = [
      lineaDireccion,
      locality,
      administrativeArea,
      postalCode,
      regionCode
    ].filter(Boolean); // Elimina elementos vacíos
  
    const direccionCompleta = partesDireccion.join(', ');
  
    return {
      pais: regionCode,
      codigoPostal: postalCode,
      departamento: administrativeArea,
      ciudad: locality,
      direccion: lineaDireccion,
      direccionCompleta,
      codigoIdioma: languageCode
    };
  }
  calculateDestination(lat: number, lng: number, distanceKm: number, bearing: number): { lat: number, lng: number } {
    const R = 6371; // Radio de la Tierra en km
    const latRad = this.degToRad(lat);
    const lngRad = this.degToRad(lng);
    const bearingRad = this.degToRad(bearing);

    const newLat = Math.asin(
      Math.sin(latRad) * Math.cos(distanceKm / R) +
      Math.cos(latRad) * Math.sin(distanceKm / R) * Math.cos(bearingRad)
    );

    const newLng = lngRad + Math.atan2(
      Math.sin(bearingRad) * Math.sin(distanceKm / R) * Math.cos(latRad),
      Math.cos(distanceKm / R) - Math.sin(latRad) * Math.sin(newLat)
    );

    return { lat: this.radToDeg(newLat), lng: this.radToDeg(newLng) };
  }


  degToRad(degrees: number): number {
    return degrees * (Math.PI / 180);
  }

  radToDeg(radians: number): number {
    return radians * (180 / Math.PI);
  }

  calcularDistancia(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 6371e3; // Radio de la Tierra en metros
    const φ1 = lat1 * Math.PI / 180;
    const φ2 = lat2 * Math.PI / 180;
    const Δφ = (lat2 - lat1) * Math.PI / 180;
    const Δλ = (lng2 - lng1) * Math.PI / 180;

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) *
      Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distancia en metros
  }
  filtrarListaConGeo(
    listaConGeo: any,
    puntoReferencia: { lat: number; lng: number },
    distanciaMaximaMetros: number = 50
  ): any[] {
    if (listaConGeo.length === 0) {
      return [];
    }
  
    // Ignorar los elementos de tipo 'point'
    const listaFiltrada = listaConGeo.filter(item => item.type !== 'point');
  
    // Separar los elementos en reports y otros tipos (excepto 'point')
    const reports = listaFiltrada.filter(item => item.type === 'report');
    const otrosTipos = listaFiltrada.filter(item => item.type !== 'report');
  
    // Procesar solo los reports
    const reportsProcesados = this.filtrarReports(reports, puntoReferencia, distanciaMaximaMetros);
  
    // Combinar los reports filtrados con los otros tipos
    return [...otrosTipos, ...reportsProcesados];
  }
  
  private filtrarReports(
    reports: any[],
    puntoReferencia: { lat: number, lng: number },
    distanciaMaximaMetros: number
  ): any[] {
    // Filtrar reports válidos (lat ≠ 0)
    const reportsValidos = reports.filter(item => parseFloat(item.lat) !== 0.0);

    if (reportsValidos.length === 0) {
      return []; // No hay reports válidos para filtrar
    }

    // Calcular distancias
    const reportsConDistancia = reportsValidos.map(item => {
      const puntoItem = new google.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng));
      const distancia = google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(puntoReferencia.lat, puntoReferencia.lng),
        puntoItem
      );
      return { item, distancia };
    });

    // Filtrar por distancia
    const reportsDentroRadio = reportsConDistancia
      .filter(r => r.distancia <= distanciaMaximaMetros)
      .map(r => r.item);

    // Si hay reports dentro del radio, devolverlos
    if (reportsDentroRadio.length > 0) {
      return reportsDentroRadio;
    }

    // Si no, devolver el report más cercano
    const reporteMasCercano = reportsConDistancia.reduce((prev, current) =>
      (prev.distancia < current.distancia) ? prev : current
    ).item;

    return [reporteMasCercano];
  }

  addGeozonaGeo(recorridos: any[], color: string, mapa: google.maps.Map): void {

    console.log("lrecorridos ", recorridos)
    // Filtrar puntos con latitud 0.0
    const filteredRecorridos = recorridos.filter(location =>
      location.type !== "point" && parseFloat(location.lat) !== 0.0
    );

    // Si no hay puntos válidos, no hacer nada
    if (filteredRecorridos.length === 0) {
      console.warn("⚠️ No hay puntos válidos para crear la geozona (todos tienen lat=0.0)");
      return;
    }

    // Ordenar por ETA
    const sortedRecorridos = [...filteredRecorridos].sort((a, b) =>
      new Date(a.eta).getTime() - new Date(b.eta).getTime()
    );

    // Asignar orden de tarea
    sortedRecorridos.forEach((location, index) => {
      location.ordenTarea = index + 1;
    });

    // Crear array de puntos válidos
    const points: PuntoConOrden[] = filteredRecorridos.map((location, index) => ({
      lat: parseFloat(location.lat),
      lng: parseFloat(location.lng),
      ordenVisita: 1,
      ordenTarea: index + 1
    }));

    // 🔹 Validar si TODOS los puntos están dentro de 20m (si es necesario)
    // ...

    // 🔹 Dibujar la geozona
    const geozonaCoords = this.createConvexHull(points);

    const geozona = new google.maps.Polygon({
      paths: geozonaCoords,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: color,
      fillOpacity: 0.3
    });

    geozona.setMap(mapa);
  }

  createConvexHull(points: google.maps.LatLngLiteral[]): google.maps.LatLngLiteral[] {
    if (points.length < 3) return points;

    // Eliminar puntos duplicados
    const uniquePoints = Array.from(new Set(points.map(p => `${p.lat},${p.lng}`)))
      .map(p => {
        const [lat, lng] = p.split(',');
        return { lat: parseFloat(lat), lng: parseFloat(lng) };
      });

    // Ordenar puntos por latitud y luego por longitud
    const sorted = uniquePoints.sort((a, b) => a.lat === b.lat ? a.lng - b.lng : a.lat - b.lat);

    // Función para calcular el producto cruzado
    const crossProduct = (o: google.maps.LatLngLiteral, a: google.maps.LatLngLiteral, b: google.maps.LatLngLiteral) =>
      (a.lat - o.lat) * (b.lng - o.lng) - (a.lng - o.lng) * (b.lat - o.lat);

    // Construir la parte inferior del convex hull
    const lower: google.maps.LatLngLiteral[] = [];
    for (const point of sorted) {
      while (lower.length >= 2 && crossProduct(lower[lower.length - 2], lower[lower.length - 1], point) < 0) {
        lower.pop();
      }
      lower.push(point);
    }

    // Construir la parte superior del convex hull
    const upper: google.maps.LatLngLiteral[] = [];
    for (const point of sorted.reverse()) {
      while (upper.length >= 2 && crossProduct(upper[upper.length - 2], upper[upper.length - 1], point) < 0) {
        upper.pop();
      }
      upper.push(point);
    }

    // Eliminar el último punto de cada parte porque está duplicado
    upper.pop();
    lower.pop();

    // Combinar las partes inferior y superior
    return lower.concat(upper);
  }

  obtenerFechas(): { fechaActual: string, fechaDosMesesAtras: string } {
    // Obtener fecha actual
    const hoy = new Date();

    // Obtener fecha dos meses atrás
    const dosMesesAtras = new Date(hoy);
    dosMesesAtras.setMonth(dosMesesAtras.getMonth() - 3);

    // Formatear a YYYY-MM-DD
    const formatearFecha = (fecha: Date): string => {
      const año = fecha.getFullYear();
      const mes = String(fecha.getMonth() + 1).padStart(2, '0');
      const dia = String(fecha.getDate()).padStart(2, '0');
      return `${año}-${mes}-${dia}`;
    };

    return {
      fechaActual: formatearFecha(hoy),
      fechaDosMesesAtras: formatearFecha(dosMesesAtras)
    };
  }

  limpiarDireccion(direccion: string): string {
    if (!direccion) return '';
  
    // Primero convertir todo a minúsculas
    let texto = direccion.trim().toLowerCase();
  
    texto = texto.replace(/[-_]/g, ' '); // Reemplazar guiones y underscores por espacios
  
    // 🔹 Eliminar patrones como "#c" (almohadilla + 1 letra)
    texto = texto.replace(/#\s*[a-zA-Z]\b/g, ''); 
  
    // 🔹 Unir números con 1, 2 o 3 letras siguientes
    texto = texto.replace(/(\d+)\s+([a-zA-Z]{1,3})\b/g, '$1$2');
  
    // 🔹 Separar si son más de 3 letras (ej: "50ABCD" → "50 ABCD")
    texto = texto.replace(/(\d+)([a-zA-Z]{4,})\b/g, '$1 $2');
  
    // Capitalizar primera letra de cada palabra, ignorando tildes
    texto = texto.replace(/(^|\s)([a-záéíóúüñ])/g, (match, espacio, letra) => {
      return espacio + letra.toUpperCase();
    });
  
    // Palabras que se deben mantener en minúsculas
    texto = texto.replace(/\b(Del?|La|Los|Las|Y|E|A|El)\b/gi, match => match.toLowerCase());
  
    // Eliminar todo después de una barra inclinada ("/")
    texto = texto.split('/')[0].trim();
  
    // Expandir abreviaturas de tipo de vía
    Object.keys(tiposVia).forEach(abreviatura => {
      const regex = new RegExp(`\\b${abreviatura}\\b`, 'gi');
      texto = texto.replace(regex, tiposVia[abreviatura]);
    });
  
    // Reemplazar caracteres no deseados
    texto = texto.replace(/[#,]/g, ' ');
    texto = texto.replace(/[#.]/g, ' ');
  
    // Unir patrones como "71Ac5" => "71Ac 5"
    texto = texto.replace(/(\d+[a-zA-Z]{1,3})(\d+)/g, '$1 $2');
  
    // Quitar espacios múltiples
    texto = texto.replace(/\s+/g, ' ').trim();
  
    return texto;
  }

   transformarDireccion(direccion : string) {
    // Diccionario de abreviaciones normalizadas
    const abreviaciones = {
      "cra": "Carrera",
      "cr": "Carrera",
      "kra": "Carrera",
      "kr": "Carrera",
      "calle": "Calle",
      "cl": "Calle",
      "cll": "Calle",
      "dg": "Diagonal",
      "dgll": "Diagonal",
      "diagonal": "Diagonal",
      "tv": "Transversal",
      "transv": "Transversal",
      "transversal": "Transversal"
    };
  
    if (!direccion) throw new Error("Dirección vacía");
  
    // Normaliza texto (quita tildes, minúsculas)
    direccion = direccion.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
  
    // Elimina caracteres especiales y reemplaza "#" o "No" por espacio
    direccion = direccion.replace(/[#\.]/g, '').replace(/\bno\b/gi, '').replace(/\s+/g, ' ');
  
    // Extrae tipo de vía, número1, número2 y número3
    const regex = /^(\w+)\s+(\d+\w*)\s+(\d+\w*)-(\d+)$/i;
    const match = direccion.match(regex);
  
    if (!match) {
      throw new Error("Formato de dirección no reconocido");
    }
  
    let [_, tipoVia, numero1, numero2, numero3] = match;
  
    const tipoViaNormalizado = abreviaciones[tipoVia.toLowerCase()];
    if (!tipoViaNormalizado) {
      throw new Error("Tipo de vía no reconocido: " + tipoVia);
    }
  
    // Cambio de tipo de vía (Carrera <-> Calle)
    let nuevoTipoVia;
    if (tipoViaNormalizado === "Carrera") {
      nuevoTipoVia = "Calle";
    } else if (tipoViaNormalizado === "Calle") {
      nuevoTipoVia = "Carrera";
    } else {
      nuevoTipoVia = tipoViaNormalizado;
    }
  
    // Remueve letras del número1 si deseas (opcional)
    const numero1Limpio = numero1.replace(/[^\d]/g, '');
  
    return `${nuevoTipoVia} ${numero2} ${numero1Limpio} ${numero3}`;
  }
  

  
/**
 * Verifica si una dirección contiene un número de calle válido (ej: "Cl 52 #51-20").
 * - Ignora códigos postales (ej: "050012").
 * - Soporta formatos comunes como "Calle 51", "#45-20", "Cra 11B".
 */
tieneNumeroDeDireccion(direccion: string): boolean {
  const patronDireccion = /(^\d+[-\/]?\d*[A-Za-z]?$|\b\d+[-\/]\d+\b|#\s*\d+|\b(?:Calle|Carrera|Cra|Cl|Avenida|Av|Diag|Dg|Trans|Tr|Diagonal)\s+\d+)/i;
  const primerSegmento = direccion.split(",")[0].trim();
  const esCodigoPostal = /^\d{5,}$/.test(primerSegmento);
  const esSoloNumero = /^\d+$/.test(primerSegmento);
  return patronDireccion.test(direccion) && !esCodigoPostal && !esSoloNumero;
}
   validateAddressStructure(address: string): AddressValidationResult {
    if (!address || address.trim().length === 0) {
      return { isValid: false, reason: "La dirección está vacía." };
    }
  
    const cleanAddress = address.trim();
  
    // 1. No debe iniciar con una sola letra
    if (/^[a-zA-Z](?![a-zA-Z])/.test(cleanAddress)) {
      return {
        isValid: false,
        reason: "La dirección no debe comenzar con una sola letra."
      };
    }
  
    // 2. Debe comenzar con un tipo de vía reconocida
    const validStreetTypes = [
      "Calle", "Carrera", "Diagonal", "Transversal",
      "Av.", "Avenida", "Cl.", "Cra.", "Autopista"
    ];
    const startsWithStreetType = validStreetTypes.some(type =>
      cleanAddress.toLowerCase().startsWith(type.toLowerCase())
    );
    if (!startsWithStreetType) {
      return {
        isValid: false,
        reason: "La dirección no comienza con un tipo de vía reconocido (como Calle, Carrera, Diagonal, etc.)."
      };
    }
  
    // 3. Debe tener al menos un número
    if (!/\d{1,3}/.test(cleanAddress)) {
      return {
        isValid: false,
        reason: "La dirección no contiene un número de vía o calle."
      };
    }
  
    // 4. Debe contener una localidad reconocida
    const localidadesReconocidas = [
      "Medellín", "Envigado", "Bello", "Itagüí", "Sabaneta", "Copacabana",
      "La Estrella", "Aranjuez", "Antioquia"
    ];
    const hasLocality = localidadesReconocidas.some(localidad =>
      cleanAddress.toLowerCase().includes(localidad.toLowerCase())
    );
    if (!hasLocality) {
      return {
        isValid: false,
        reason: "La dirección no contiene una localidad reconocida."
      };
    }
  
    return {
      isValid: true,
      reason: "La dirección tiene una estructura válida."
    };
  }

  
   calcularDistanciaEnKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radio de la Tierra en km
    const toRad = (valor: number) => (valor * Math.PI) / 180;
  
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
  
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
  
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }
   formatAddressGoogle(addressComponents: any[]): string {
    if (!addressComponents || !Array.isArray(addressComponents)) {
        return '';
    }

    // Función auxiliar para extraer componentes SIN operador ?.
    function getComponent(types: string): string | null {
        if (!types) return null;
        const component = addressComponents.find(c => 
            c && c.types && Array.isArray(c.types) && c.types.includes(types)
        );
        return component && component.long_name ? component.long_name : null;
    }

    // Extraer componentes (retorna null si no existen)
    //const streetNumber = getComponent('street_number');
    const route = getComponent('route');
    const neighborhood = getComponent('neighborhood');
    const locality = getComponent('locality');
    const postalCode = getComponent('postal_code');
    const country = getComponent('country');
    const administrative = getComponent('administrative_area_level_1');
    const sublocality_level_1 = getComponent('sublocality_level_1');

    // Array para construir la dirección
    const addressParts: string[] = [];

    // 1. Calle + número (ej: "Carrera 10 # 20-30")
    /*
    if (route) {
        const streetPart = streetNumber ? route + ' ' + streetNumber : route;
        addressParts.push(streetPart);
    }
    */

    // 2. Barrio (si existe y no está repetido en la localidad)
    if (neighborhood && locality && locality.indexOf(neighborhood) === -1) {
        addressParts.push(neighborhood);
    }

    // 3. Sublocalidad (si existe)
    if (sublocality_level_1) {
        addressParts.push(sublocality_level_1);
    }

    // 4. Ciudad + código postal (ej: "Bogotá, 110111")
    if (locality) {
        const localityPart = postalCode ? locality + ', ' + postalCode : locality;
        addressParts.push(localityPart);
    }

    // 5. Departamento/Estado (si existe)
    if (administrative) {
        addressParts.push(administrative);
    }

    // 6. País (opcional, si no es Colombia)
    if (country && country.toLowerCase() !== 'colombia') {
        addressParts.push(country);
    }

    // Unir todas las partes válidas con ", "
    return addressParts.filter(part => part != null).join(', ');
}
 eliminarCommas(direccion) {
  return direccion.replace(/,/g, '');
}
  formatAddress(addressModel) {
    const { street, houseNumber, city, district, postalCode, countryName } = addressModel;
    const parts = [
        `${street}-${houseNumber}`,
        district && ` ${district}`, // Opcional: añade el barrio si existe
        city,
        postalCode,
        countryName
    ].filter(Boolean); // Elimina elementos vacíos/undefined

    return parts.join(', ');
}

// Output con distrito: "Calle 62 52-36, Barrio La Candelaria, Medellín, 050010, Colombia"

   calcularDistanciaEnMetros(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radio de la Tierra en kilómetros
    const toRad = (valor: number) => (valor * Math.PI) / 180;
  
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
  
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
  
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distanciaEnKm = R * c;
    return Math.round(distanciaEnKm * 1000); // Convertir a metros y redondear a entero
  }
  
  
  
  
  limpiarDireccionUnica(direccion: string): string {
    if (!direccion) return '';
  
    const palabras = direccion.split(' ');
    const ultimaAparicion = new Map<string, number>();
  
    // Guardar la última posición de cada palabra (normalizada)
    palabras.forEach((palabra, index) => {
      const normalizada = palabra.toLowerCase();
      ultimaAparicion.set(normalizada, index);
    });
  
    const resultado: string[] = [];
    let incluirColombia = false;
  
    palabras.forEach((palabra, index) => {
      const normalizada = palabra.toLowerCase();
      if (normalizada === 'colombia') {
        if (ultimaAparicion.get(normalizada) === index) {
          incluirColombia = true; // Marcamos que sí debe ir al final
        }
        return; // Omitir todas las apariciones de Colombia por ahora
      }
  
      if (ultimaAparicion.get(normalizada) === index) {
        resultado.push(palabra);
      }
    });
  
    if (incluirColombia) {
      resultado.push('Colombia');
    }
  
    return resultado.join(' ');
  }
  

  
  getFormattedAddress(response: any, includePostalCode: boolean = false): string {


    const addressParts: string[] = [];

    // Filtrar componentes (incluyendo/excluyendo código postal según parámetro)
    const components = includePostalCode
      ? [...response.result.address.addressComponents]
      : response.result.address.addressComponents.filter(
        (component: any) => component.componentType !== 'postal_code'
      );

    // Ordenar componentes
    const orderedComponents = components.sort((a: any, b: any) => {
      const order = {
        route: 1,
        street_number: 2,
        locality: 3,
        administrative_area_level_1: 4,
        country: 5,
        postal_code: 6
      };
      return order[a.componentType] - order[b.componentType];
    });

    // Construir dirección
    orderedComponents.forEach((component: any) => {
      if (component.componentName.text) {
        // Formatear número de calle con guión si aplica
        if (component.componentType === 'street_number') {
          const streetNumber = component.componentName.text.replace(/\s+/g, '-');
          addressParts[1] = addressParts[1] ? `${addressParts[1]} ${streetNumber}` : streetNumber;
        } else {
          addressParts.push(component.componentName.text);
        }
      }
    });

    return addressParts.join(', ');
  }

   extraerUbicacionGeografica(direccion: string): string {
    const partes = direccion.split(',').map(p => p.trim());
    if (partes.length >= 3) {
      return partes.slice(-3).join(', '); // Ciudad, Departamento, País
    } else if (partes.length >= 2) {
      return partes.slice(-2).join(', '); // Departamento, País
    }
    return direccion; // Si no hay suficientes partes, retorna todo
  }
  


  isDistanceGreaterThan150m(
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number
  ): boolean {
    const R = 6371e3; // Radio de la Tierra en metros
    const φ1 = (lat1 * Math.PI) / 180; // Convertir a radianes
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lng2 - lng1) * Math.PI) / 180;

    // Fórmula de Haversine
    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distancia en metros

    return distance > 150;
  }

  isDistanceGreater500(
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number
  ): boolean {
    const R = 6371e3; // Radio de la Tierra en metros
    const φ1 = (lat1 * Math.PI) / 180; // Convertir a radianes
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lng2 - lng1) * Math.PI) / 180;

    // Fórmula de Haversine
    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distancia en metros

    return distance > 500;
  }
  
  reemplazarItemPorVisitLabel(lista: any[], nuevoItem: any): any[] {
    const index = lista.findIndex(item => item.visitLabel === nuevoItem.visitLabel);
    if (index !== -1) {
      // Crear una nueva copia del array para asegurar la detección de cambios
      const nuevaLista = [...lista];
      nuevaLista[index] = nuevoItem;
      return nuevaLista;
    }
    return lista;
  }

  tratamientoGeneral(item:any): string {
    const addressParts = [
      item.Address,
      item.Administrative,
      item.Locality,
      item.Country
    ];
  
    const fullAddress = addressParts
      .filter(part => part && part.trim().length > 0)
      .join(' ')
      .trim();
  
    item.VRTIA_AddressInit = fullAddress;
    return fullAddress;
  }

  /**
 * Extrae el dominio empresarial de un correo electrónico si aplica.
 * Devuelve null si el correo no existe, es inválido o es de un dominio común.
 */
  extraerDominioEmpresarial(email: string | null | undefined): string | null {
    if (!email || typeof email !== 'string') return null;
  
    const correo = email.trim().toLowerCase();
  
    // Validación básica del formato del email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(correo)) return null;
  
    const dominioCompleto = correo.split('@')[1];
  
    // Lista de dominios comunes
    const dominiosComunes = [
      'gmail.com', 'hotmail.com', 'yahoo.com', 'outlook.com',
      'icloud.com', 'protonmail.com', 'live.com', 'msn.com', 'aol.com'
    ];
  
    if (dominiosComunes.includes(dominioCompleto)) return null;
  
    // Separar el dominio en partes
    const partesDominio = dominioCompleto.split('.');
    
    // Obtener el nombre principal del dominio (último antes del TLD)
    // Ej: "empresa.com" => "empresa", "miempresa.net" => "miempresa"
    if (partesDominio.length >= 2) {
      return partesDominio[partesDominio.length - 2];
    }
  
    return null;
  }
  

  
  normalizeText(text: string): string {
    try {
      return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/\b(s\.a\.s|sas|s\.a|ltda|l\.t\.d\.a)\b/g, '')
        .replace(/[\u0300-\u036f]/g, "") // eliminar tildes
        .replace(/[^\w\s]/g, "")         // eliminar signos
        .trim();
    } catch (error) {
      console.warn("⚠️ Error en normalizeText con valor:", text, "->", error);
      return "";
    }
  }
  
   cleanString(str, forceLowerCase = true) {
    // Si str es undefined, null o no es string, devolver cadena vacía (o str si prefieres)
    if (str == null || typeof str !== 'string') {
      return ''; // o return str; si quieres conservar el valor original (undefined/null)
    }
  
    let cleanedStr = str;
    
    // Aplicar lowercase solo si forceLowerCase es true
    if (forceLowerCase) {
      cleanedStr = cleanedStr.toLowerCase();
    }
    
    // Eliminar caracteres no alfanuméricos y espacios extra
    cleanedStr = cleanedStr.replace(/[\W_]+/g, '').trim();
    
    return cleanedStr;
  }
  
   levenshteinSimilarity(a: string, b: string): number {
    const normalize = (str: string) =>
  
   str = this.cleanString(str)
    a = normalize(a);
    b = normalize(b);
  
    const matrix = Array.from({ length: a.length + 1 }, (_, i) =>
      Array.from({ length: b.length + 1 }, (_, j) =>
        i === 0 ? j : j === 0 ? i : 0
      )
    );
  
    for (let i = 1; i <= a.length; i++) {
      for (let j = 1; j <= b.length; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,     // delete
          matrix[i][j - 1] + 1,     // insert
          matrix[i - 1][j - 1] + cost // substitute
        );
      }
    }
  
    const distance = matrix[a.length][b.length];
    const maxLen = Math.max(a.length, b.length);
    const similarity = 1 - distance / maxLen; // Valor entre 0 (diferente) y 1 (idéntico)
  
    // Si la similitud es mayor al 50%, devolvemos un valor mayor a 3
    return similarity > 0.5 ? 4 : similarity * 3; // Si es mayor al 50% devolvemos 4, sino multiplicamos por 3
  }

  
   countWordMatches(a: string, b: string): number {
    const normalize = (text: string): string[] =>
      text
        .toLowerCase()
        .replace(/[\.,#]/g, '')          // elimina puntuaciones
        .replace(/\s*-\s*/g, '-')        // conserva guiones entre números
        .replace(/\s+/g, ' ')            // colapsa espacios
        .trim()
        .split(' ');                     // divide por palabras
  
    const wordsA = new Set(normalize(a));
    const wordsB = new Set(normalize(b));
  
    let matchCount = 0;
    for (const word of wordsA) {
      if (wordsB.has(word)) {
        matchCount++;
      }
    }
  
    return matchCount;
  }
  
  
  
  findClosestBusinessByName(nameToFind: string, direccion: string, places: any[]): { place: any | null, matchScore: number, nameMatches: number } {
    if (places.length === 1) {
      const direccionLower =  places[0].formatted_address.toLowerCase();
      if (direccionLower.includes("antioquia")) {
        //return { place: places[0], matchScore: 101010 }; // match directo si contiene "Antioquia"
      }
      // si no contiene "Antioquia", sigue con el proceso normal
    }
    
  
    const target = this.normalizeText(nameToFind);
    let bestMatch: any = null;
    let maxMatches = 0;
    let nameMatchesView = 0;
  
    for (const place of places) {
      const placeName = place.name ? this.normalizeText(place.name) : "";
      const placeVicinity = place.vicinity ? place.vicinity : "";
  
      if (placeName === target || placeVicinity === target) {
     //   return { place, matchScore: 101010 , nameMatches: 10 }; // match perfecto
      }
  
      const nameMatches = this.countWordMatches(target, place.name || "");
      console.log("nameMatches", nameMatches)
      const vicinityMatches = this.levenshteinSimilarity(direccion, place.vicinity ||  place.formatted_address);
      const totalMatches = nameMatches + vicinityMatches;
      console.log("direccion", direccion)
      console.log("place.vicinity ", place.vicinity )
      console.log("vicinityMatches", vicinityMatches)
      if (nameMatches > 0 && totalMatches > maxMatches && vicinityMatches > 3) {
        maxMatches = totalMatches;
        bestMatch = place;
        nameMatchesView =  nameMatches
      }
    }
  
    if (!bestMatch) {
      return { place: null, matchScore: 0, nameMatches:0 };
    }
  
    return { place: bestMatch, matchScore: maxMatches, nameMatches:nameMatchesView  };
  }
  findClosestBusinessByNameVici(nameToFind: string, direccion: string, places: any[]): { place: any | null, matchScore: number, nameMatches: number } {
    if (places.length === 1) {
      const direccionLower =  places[0].formatted_address.toLowerCase();
      if (direccionLower.includes("antioquia")) {

        const vicinityMatches = this.levenshteinSimilarity(direccion,  direccionLower);
        console.log("nameMatches vicinityMatches vicinityMatches", vicinityMatches)
        if ( vicinityMatches > 0) {

          console.log("vicinityMatches ingreo")
          return { place: places[0], matchScore: 101010, nameMatches:10 }; // match directo si contiene "Antioquia"
     
        }
      }
      // si no contiene "Antioquia", sigue con el proceso normal
    }
    
  
    const target = this.normalizeText(nameToFind);
    let bestMatch: any = null;
    let maxMatches = 0;
    let nameMatchesView = 0;
  
    for (const place of places) {
      const placeName = place.name ? this.normalizeText(place.name) : "";
      const placeVicinity = place.vicinity ? place.formatted_address : place.formatted_address;
  
      if (placeName === target || placeVicinity === target) {
     //   return { place, matchScore: 101010 , nameMatches: 10 }; // match perfecto
      }
  
      const nameMatches = this.levenshteinSimilarity(target, place.name || "");
      console.log("nameMatches", nameMatches)
      const vicinityMatches = this.levenshteinSimilarity(direccion,  placeVicinity);
      const totalMatches = nameMatches + vicinityMatches;
      console.log("direccion", direccion)
      console.log("place.vicinity ", placeVicinity )
      console.log("vicinityMatches", vicinityMatches)
      if (nameMatches > 0 && totalMatches > maxMatches && vicinityMatches > 3) {
        maxMatches = totalMatches;
        bestMatch = place;
        nameMatchesView =  nameMatches
      }
    }
  
    if (!bestMatch) {
      return { place: null, matchScore: 0, nameMatches:0 };
    }
  
    return { place: bestMatch, matchScore: maxMatches, nameMatches:nameMatchesView  };
  }
  

/**
 * Encuentra el lugar con el nombre más similar al buscado y devuelve el lugar junto con su puntaje de coincidencia.
 * @param searchName Nombre a comparar.
 * @param items Lista de lugares (debe tener propiedad `name`).
 * @returns { place: any | null, matchScore: number } 
 *   - `place`: El objeto más similar o `null` si no hay coincidencias.
 *   - `matchScore`: Puntaje de similitud (0 = nada similar, 1 = idéntico).
 */
findClosestBusinessByNameFalla(searchName: string, items: any[]): { place: any | null, matchScore: number } {
  if (!items || items.length === 0) {
    return { place: null, matchScore: 0 };
  }

  let minDistance = Infinity;
  let mostSimilarPlace = null;

  // Normaliza el nombre de búsqueda para comparación insensible a mayúsculas/tildes
  const normalizedSearchName = this.normalizarTexto(searchName);

  for (const item of items) {
    const normalizedItemName = this.normalizarTexto(item.name);
    const distance = this.levenshteinDistance(normalizedSearchName, normalizedItemName);

    if (distance < minDistance) {
      minDistance = distance;
      mostSimilarPlace = item;
    }
  }

  // Calcula el "matchScore" (1 = igual, <1 = menos similar)
  const maxLength = Math.max(searchName.length, mostSimilarPlace.name.length || 0);
  const matchScore = maxLength > 0 ? (1 - minDistance / maxLength) : 0;

  return {
    place: mostSimilarPlace,
    matchScore: parseFloat(matchScore.toFixed(2)) // Redondea a 2 decimales
  };
}

findClosestBusinessByNameNo(searchName: string, items: any[]): { place: any | null, matchScore: number } {
  if (!items || items.length === 0) {
    return { place: null, matchScore: 0 };
  }

  const normalizedSearch = this.normalizarTexto(searchName);
  let bestMatch = { place: null, matchScore: 0 };

  for (const item of items) {
    const normalizedItemName = this.normalizarTexto(item.name);

    // 1. Coincidencia exacta (score = 1.0)
    if (normalizedItemName === normalizedSearch) {
      return { place: item, matchScore: 1.0 };
    }

    // 2. Coincidencia parcial (si el nombre buscado está dentro del nombre del item)
    const isPartialMatch = normalizedItemName.includes(normalizedSearch) || 
                          normalizedSearch.includes(normalizedItemName);
    
    // 3. Levenshtein ratio (similitud normalizada)
    const distance = this.levenshteinDistance(normalizedSearch, normalizedItemName);
    const maxLength = Math.max(normalizedSearch.length, normalizedItemName.length);
    const similarityRatio = 1 - (distance / maxLength);

    // Prioriza coincidencias parciales o high-ratio
    const score = isPartialMatch ? Math.max(0.8, similarityRatio) : similarityRatio;

    if (score > bestMatch.matchScore) {
      bestMatch = { place: item, matchScore: parseFloat(score.toFixed(2)) };
    }
  }

  // Solo devuelve matches con score >= 0.4 (ajustable)
  return bestMatch.matchScore >= 0.2 ? bestMatch : { place: null, matchScore: 0 };
}
  
  /**
 * Calcula la distancia de Levenshtein entre dos cadenas.
 * @param a Primera cadena.
 * @param b Segunda cadena.
 * @returns Número de operaciones necesarias para convertir `a` en `b`.
 */
 levenshteinDistance(a: string, b: string): number {
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  const matrix = [];

  // Inicializa la primera fila y columna de la matriz
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }

  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  // Llena la matriz con las distancias
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      const cost = a.charAt(j - 1) === b.charAt(i - 1) ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,     // Eliminación
        matrix[i][j - 1] + 1,     // Inserción
        matrix[i - 1][j - 1] + cost // Sustitución
      );
    }
  }

  return matrix[b.length][a.length];
}


}
